export function attachProductListeners() {
  let productCards = document.querySelectorAll(".section-featured-products .home-featured-products a");
  let productButtons = document.querySelectorAll(".section-featured-products .btn");

  if(productCards) {
    productCards.forEach(card => {
      card.addEventListener("click", pushGTMData);
    })
  }

  if(productButtons) {
    productButtons.forEach(button => {
      button.addEventListener("click", pushAddGTMData);
    })
  }
}

function pushGTMData(event) {
  let productName = event.currentTarget.querySelector("h2").innerText;

  dataLayer.push({
    'event': 'gtm-click',
    'clickType': 'product click',
    'clickName': 'featured products',
    'productName': productName.replace(/'/g,"")
  })
}

function pushAddGTMData(event) {
  let currentCard = event.currentTarget.closest(".featured-productsh");
  let productName = currentCard.querySelector("h2").innerText;

  dataLayer.push({
    'event': 'gtm-click',
    'clickType': 'add to basket',
    'clickName': 'featured products',
    'productName': productName.replace(/'/g,"")
  })
}